@if (definition) {
  <div class="row">
    @for (tile of definition.value.tiles; track tile) {
      <div class="tile-col col-{{12 / definition.value.columns}}">
        <a href="{{ tile.value.url }}" class="tile-wrapper">
          <span class="tile-inner">
            @if (tile.value.picture_tag_info) {
              <img class="d-block w-100"
                src="{{getImagePath(tile)}}"
                alt="{{ tile.value.picture_tag_info.alt.join(' ') }}"
                />
            }
            <span class="tile-content" >
              <span class="tile-punktrahmen"></span>
              <span class="tile-heading">
                <span>{{ tile.value.row_1 }}</span>
              </span>
            </span>
          </span>
        </a>
      </div>
    }
  </div>
}
